module.exports = __webpack_public_path__ + "fonts/font.0dafb71.woff2";